exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.alert p {\n    margin: 0;\n    padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/tcochran/Desktop/programming/gradpad-dash/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/tcochran/Desktop/programming/gradpad-dash/node_modules/postcss-loader?{"ident":"postcss"}!/Users/tcochran/Desktop/programming/gradpad-dash/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles